// extracted by mini-css-extract-plugin
export default {"mobile":"_7UsEs","header":"_0wR+8","content":"o+kBz","ff":"On4xO","desktop":"vXc68","container":"ft6qZ","headerCont":"pWEL6","controls":"Ioaam"};